/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React from 'react';

import {useTranslation} from 'react-i18next';

interface Props {
    errors: Array<string>;
}

export default function ValidationErrors({errors}: Props) {
    const {t} = useTranslation();
    return (
        <p>
            {t('misc.validationErrors.title', 'De volgende fouten zijn opgetreden:')}
            <ul style={{marginTop: '.5rem'}}>
                {errors.map((error: string) => (
                    <li>{error}</li>
                ))}
            </ul>
        </p>
    );
}
